import { AxiosResponse } from 'axios';
import Api from './Api';

export default class ConsultorFaturas {
  public static async get(request?: IRequestOptions): Promise<GetFaturasResponse> {
    const response = await Api.instance.get<GetFaturasResponse>(`/consultor/faturas`, {
      params: request?.params,
    });
    return response.data;
  }

  public static async getByID(id: number): Promise<GetFaturaResponse> {
    const response = await Api.instance.get<GetFaturaResponse>(`/consultor/faturas/${id}`);
    return response.data;
  }

  public static async exportar(request?: IRequestOptions): Promise<AxiosResponse<string>> {
    const response = await Api.instance.get<string>(`/consultor/faturas`, { params: request?.params });
    return response;
  }
}
